import { Box, Button, styled } from "@mui/material";

export const EngageWrapper = styled(Box)({
    "& .wrapper": {
        paddingLeft: "35px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingBottom: "50px",
    },
    "& .wrapper .row": {
        position: "relative",
        marginTop: "30px",
    },
    "& .wrapper .row section": {
        position: "relative",
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        paddingTop: "20px",
        paddingLeft: 0,
    },
    "& .row section .DotIcon": {
        position: "absolute",
        textAlign: "center",
        top: -12,
        left: -30,
    },
    "& .row section p": {
        marginTop: -34,
        fontSize: "15px",
    },
    "& .error_noti": {
        width: "100%",
        borderRadius: 5,
        marginBottom: 35
    },
    "& .error_noti .page_not_found svg": {
        color: "red",
        marginRight: 10,
    },
    "& .error_noti .page_not_found .inner": {
        display: "flex",
        maxWidth: "max-content",
        margin: "auto",
        color: "#3572a6"
    },
    "& .error_noti .error_message": {
        display: "block",
        fontSize: 16,
        padding: 5,
        textAlign: "center",
        maxWidth: "fit-content",
        margin: "auto",
        marginTop: 10,
        borderRadius: 5,
        color: "#3572a6",
    },
    "& .error_noti .page_not_found": {
        display: "flex",
        fontSize: 16,
        marginTop: "20%",
    }
});

export const StyledSubmitButton = styled(Button)({
    borderRadius: 10,
    width: "100%",
    backgroundColor: "#F5F8FF",
    color: "#141416",
    fontSize: 14,
    fontWeight: 700,
    padding: "17px 20px",
    "&:hover": {
        backgroundColor: "#F5F8FF",
    },
    "& svg": {
        marginRight: 10,
        width: 20,
        height: 20
    }
});

export const StepsContainer = styled(Box)({
    marginTop: "15px",
    marginBottom: 45,
    marginLeft: 20,
    marginRight: 20,
});
